module.exports = __webpack_public_path__ + "static/media/whatsapp-business-bg-min.453a3fc0.png";